import { useSessionStore } from "../../../state/src/useSessionStore";
import { AuthConsumerPostParameter } from "../view-models/AuthConsumerPostParameter";

export const buildAuthConsumerPostParameter = (): AuthConsumerPostParameter => {
    const s = (useSessionStore as any).getState?.() || {};
    const request = new AuthConsumerPostParameter();
    request.agentID = s.agentId || undefined;
    request.unitProfileID = s.unitProfileId || undefined;
    request.ConsumerPhone = s.phoneNumber || undefined;
    request.PIN = s.consumerPin  || undefined;
    return request;
};
